<template>
  <a-drawer :title="title" :maskClosable="true" width=650 placement="right" :closable="true" @close="close" :visible="visible"
    style="overflow: auto;padding-bottom: 53px;">

    <a-form>
      <a-form-item :label="$t('可跳转的路由')">
        <!-- :checkStrictly="checkStrictly" -->
        <a-tree checkable @check="onCheck" :disableCheckbox="true" :checkedKeys="checkedKeys" :treeData="treeData" @expand="onExpand" @select="onTreeNodeSelect"
          :selectedKeys="selectedKeys" :expandedKeys="expandedKeysss"  :checkStrictly="checkStrictly">
          <span slot="hasDatarule" slot-scope="{slotTitle,ruleFlag}">
            {{ slotTitle }}<a-icon v-if="ruleFlag" type="align-left" style="margin-left:5px;color: red;"></a-icon>
          </span>
        </a-tree>
      </a-form-item>
    </a-form>

    <div class="drawer-bootom-button">
      <!-- <a-dropdown style="float: left" :trigger="['click']" placement="topCenter">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="switchCheckStrictly(1)">父子关联</a-menu-item>
          <a-menu-item key="2" @click="switchCheckStrictly(2)">取消关联</a-menu-item>
          <a-menu-item key="3" @click="checkALL">全部勾选</a-menu-item>
          <a-menu-item key="4" @click="cancelCheckALL">取消全选</a-menu-item>
          <a-menu-item key="5" @click="expandAll">展开所有</a-menu-item>
          <a-menu-item key="6" @click="closeAll">合并所有</a-menu-item>
        </a-menu>
        <a-button>
          树操作 <a-icon type="up" />
        </a-button>
      </a-dropdown> -->
      <a-popconfirm :title="$t('确定放弃编辑？')" @confirm="close" :okText="$t('确定')" :cancelText="$t('取消')">
        <a-button style="margin-right: .8rem">{{ $t('取消') }}</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit(false)" type="primary" :loading="loading" ghost style="margin-right: 0.8rem">{{ $t('仅保存') }}</a-button>
      <a-button @click="handleSubmit(true)" type="primary" :loading="loading">{{ $t('保存并关闭') }}</a-button>
    </div>

    <!-- <role-datarule-modal ref="datarule"></role-datarule-modal> -->

  </a-drawer>

</template>
<script>
import { postAction, getAction } from '@/api/manage';
import i18n from '@/i18n'

export default {
  name: "selectQuickMenu",
  components: {},
  data() {
    return {
      roleId: "",
      treeData: [],
      defaultCheckedKeys: [],
      checkedKeys: [],
      expandedKeysss: [],
      allTreeKeys: [],
      autoExpandParent: true,
      checkStrictly: true,
      title: i18n.t("添加快速导航"),
      visible: false,
      loading: false,
      selectedKeys: [],
      menuId: [],
      url: {
        tagMenu: "/jeecg-system/user/userMenuDetail/queryTreeListByUser",
        userMenu: "/jeecg-system/user/userMenuDetail/list",// 获取快捷导航
        addvMenuUser: "/jeecg-system/user/userMenuDetail/add"
      },

    }
  },
  methods: {
    onTreeNodeSelect(id,e) {
      if (id && id.length > 0) {
        this.selectedKeys = id
      }
      // 点击标题复选框选中
      e.node.$el.childNodes[1].click()
      // this.$refs.datarule.show(this.selectedKeys[0], this.roleId)
    },
    onCheck(o) {
      console.log(o, 55555555555);
      this.menuId = o
      if (this.checkStrictly) {
        this.checkedKeys = o.checked;
      } else {
        this.checkedKeys = o


      }
    },
    show() {
      // this.roleId = roleId
      this.visible = true;
    },
    close() {
      this.reset()
      this.$emit('close');
      this.visible = false;
    },
    onExpand(expandedKeys) {
      this.expandedKeysss = expandedKeys;
      this.autoExpandParent = false
    },
    reset() {
      this.expandedKeysss = []
      this.checkedKeys = []
      this.defaultCheckedKeys = []
      this.loading = false
    },
    expandAll() {
      this.expandedKeysss = this.allTreeKeys
    },
    closeAll() {
      this.expandedKeysss = []
    },
    checkALL() {
      this.checkedKeys = this.allTreeKeys
    },
    cancelCheckALL() {
      //this.checkedKeys = this.defaultCheckedKeys
      this.checkedKeys = []
    },
    switchCheckStrictly(v) {
      if (v == 1) {
        this.checkStrictly = false
      } else if (v == 2) {
        this.checkStrictly = true
      }
    },
    handleCancel() {
      this.close()
    },
    handleSubmit(exit) {
      console.log(exit, 123222222222);
      let that = this;
      let params = {};
      params = {
        permissionId: this.checkedKeys,
        userId: this.$store.getters.userInfo.id,
        sysType: 10,
      }
      that.loading = true;
      console.log("请求参数：", params);


      postAction(this.url.addvMenuUser, params).then((res) => {
        if (res.success) {
          this.requestDataSource = res.result
          that.loading = false;
          if (exit) {
            that.close()
            this.$emit('myQuickMenu');
          }
        } else {
          this.$message.warning(res.message)
          that.loading = false;
          if (exit) {
            that.close()
          }
        }
        this.loadData();

      }).finally(() => {

      })
    },
    setTreeData(arr){
      arr.map(val=>{
        if(val.slotTitle == '工作台'){
          val.disabled = true;
        }
        if(!val.isLeaf && val.children && val.children.length>0){
          val.disabled = true;
        }
        if(val.children&&val.children.length>0){
          this.setTreeData(val.children);
        }
      })
      return arr;
    },
    loadData() {
      getAction(this.url.tagMenu).then(res => {
        if (res.success) {
          // this.treeData = res.result.treeList.map(item => ({ ...item, disabled: item.slotTitle !== "首页" }))
          var oaTreeList = res.result.treeList.find(val=>val.slotTitle == "OA办公").children;// 过滤出OA办公的
          this.treeData = this.setTreeData(oaTreeList);
          console.log(" this.treeData", this.treeData)
          this.checkedKeys = [];
          getAction(this.url.userMenu,{userId:this.$store.getters.userInfo.id,pageSize:999}).then((res) => {
            if (res.success) {
              res.result.records.map(val=>{
                this.checkedKeys.push(val.permissionId);
              })
            } else {
              this.$message.warning(res.message)
            }
          })
        }
      })
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        this.loadData();
      }
    }
  }
}

</script>
<style lang="less" scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>